import ForgotPasswordPage from "./ForgotPasswordPage";

export const ForgotPasswordPageConfig = {
  routes: [
    {
      path: "/pages/auth/forgot-password",
      exact: true,
      component: ForgotPasswordPage
    }
  ]
};
